import {Component, OnInit, ViewChild} from '@angular/core';
import {ChartType, IntervalName, ReportService} from './report.service';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {mergeMap} from 'rxjs';
import {SlickCarouselComponent} from 'ngx-slick-carousel';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

    title: any = null;
    subtitle: any = null;
    anxietyData: any = null;
    performanceData: any = null;
    depressionData: any = null;
    reactions: any = null;

    barValues: any[] = [];
    burnoutData: any = null;
    recommendations: any = null;

    importantParameters: any[] = [];
    loading = false;

    dashboards: any[] = [];
    selectedDashboard = null;

    report: any;
    sunData: any;
    currentSlide = 0;
    @ViewChild('slickModal') slickModal: SlickCarouselComponent;

    constructor(
        private service: ReportService,
        private auth: AuthService
    ) {
    }

    ngOnInit(): void {
        this.dashboards = this.auth.userState?.dashboards;
        if (!this.dashboards && !this.dashboards.length) {
            return;
        }
        this.loadData(this.dashboards[0]);
    }

    loadData(selectedDashboard: any) {
        this.loading = true;
        this.selectedDashboard = selectedDashboard;

        this.service.refreshDashboard(selectedDashboard)
            .pipe(
                mergeMap(() => {
                    return this.service.fetchData(selectedDashboard);
                })
            )
            // this.service.fetchData(selectedDashboard)
            .subscribe((res: any) => {
                this.report = res;
                this.loading = false;
                this.drawData(this.report.period[0]);
            }, () => {
                this.loading = false;
            });
    }

    afterSlideChange(prop: any) {
        this.currentSlide = prop.currentSlide;
    }

    goTo(i: any) {
        this.currentSlide = i;
        this.slickModal.slickGoTo(i);
    }

    drawData(data: any) {
        this.title = data.title;
        this.subtitle = data.subtitle;
        this.anxietyData = data[ChartType.anxiety];
        this.anxietyData = data[ChartType.anxiety];
        this.depressionData = data[ChartType.depression];
        this.performanceData = this.service.mapPerformanceData(data[ChartType.performance]);
        this.reactions = this.service.mapReactionsData(data.reactions, this.selectedDashboard);
        this.importantParameters = data.important_parameters;
        this.burnoutData = data.burnout;
        this.barValues = this.service.mapBarValues(data.details);
        this.recommendations = data.recommendations;

        const texts = [
            'minimal', 'mild', 'moderate', 'severe',
        ];

        this.sunData = {
            name: 'root', children: data.details.map((el: any, k: any) => {
                el.name = `u${k}`;
                el.children = Object.values(el.data).map((item: any, i) => {
                    return {name: `c${i}`, text: texts[i], value: item};
                });
                return el;
            })
        };
    }

}
